import React from 'react';

// Impaginazione delle guide per allenatori e utenti: una colonna sola (si leggono soprattutto
// da telefono) con l'indice in alto a "pillole". I mattoncini del testo vengono da pages/Guida.js.
export default function GuidaPagina({ titolo, sottotitolo, sezioni, children }) {
  const vai = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return (
    <div style={{ maxWidth: '760px', margin: '0 auto', paddingBottom: '80px' }}>
      <div style={{ fontFamily: "'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight: 800, letterSpacing: '2px' }}>{titolo}</div>
      {sottotitolo && <div style={{ color: 'var(--text-dim)', fontSize: 'var(--font-size-sm)', marginTop: '4px', lineHeight: 1.6 }}>{sottotitolo}</div>}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', margin: '18px 0 30px' }}>
        {sezioni.map(({ id, label }) => (
          <button key={id} onClick={() => vai(id)}
            style={{ background: 'var(--bg-card,#141414)', border: '1px solid var(--border,#1E1E1E)', borderRadius: '99px', padding: '6px 12px', color: 'var(--text)', fontSize: 'var(--font-size-xs)', fontWeight: 700, cursor: 'pointer' }}>
            {label}
          </button>
        ))}
      </div>
      {children}
    </div>
  );
}

export const Sezione = ({ id, children }) => (
  <section id={id} style={{ marginBottom: '48px', scrollMarginTop: '16px' }}>{children}</section>
);
